import {useEffect} from 'react'

const useOnBeforeUnload = (onBeforeUnload: () => void) => {
  useEffect(() => {
    global.addEventListener('beforeunload', onBeforeUnload, false)

    return () => global.removeEventListener('beforeunload', onBeforeUnload, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useOnBeforeUnload
